export default "__VITE_ASSET__Cfu2tpIs__"